export default function scheduled ({ to, next, store, nextVue }){

    if( !store.state.data?.get?.id )
    {
        store.dispatch("api_get_ic", to.params.ic_url).then(() => {
            return initSchedule(to, next, store, nextVue);
        });
    }
    else
    {
        return initSchedule(to, next, store, nextVue);
    }
}

function initSchedule(to, next, store, nextVue)
{
    //check schedule
    if( store.state.data )
    {
        store.dispatch("scheduleCheck");
    }

    if( !store.state.data.isRunning && to.name!='cover')
    {
        return nextVue({
            path: '/'+to.params.ic_url +'/cover',
            query: to.query
        })
    }

    return next();
}